module.exports = __webpack_public_path__ + "img/cooperation_process1.47864aca.png";